import type { ReactNode } from "react";
import { HelpBubble } from "@/components/help/HelpBubble";
import { HelpPanel } from "@/components/help/HelpPanel";
import { isProduction } from "@/config/publicEnv";
import { HelpPanelProvider } from "@/context/HelpPanelContext";

/**
 * The Help Center mount unit for an authenticated layout: the provider, the HelpPanel slide-over
 * and the HelpBubble. One per layout — the dashboard shell and the campaign builder each mount one.
 * Children render inside the provider because the sidebar's Support item calls useHelpPanel.
 */
export function HelpCenter({
  children,
  bubbleObscured = false,
}: {
  children: ReactNode;
  bubbleObscured?: boolean;
}) {
  return (
    <HelpPanelProvider>
      {children}
      <HelpPanel />
      {/* The Help Center is internal-only for now: hide the "?" bubble trigger in production (env
          reported by the API via /api/config); it stays on staging/dev. The panel + provider stay
          mounted so the sidebar's useHelpPanel hook keeps working even when the trigger is hidden. */}
      {!isProduction() && <HelpBubble obscured={bubbleObscured} />}
    </HelpPanelProvider>
  );
}
